import React from 'react'
import cn from 'classnames'
import Router from 'next/router'
import { EditorContent } from '@tiptap/react'

import { ThemeEnum } from '@hooks/contexts/ThemeContext/interface'
import { TiptapViewerProps } from './interface'

function TiptapViewer({
  theme,
  editor,
  className,
  contentSize,
  contentLine,
  showMore,
  showMoreButton,
  toggleShowMore,
}: TiptapViewerProps) {
  return (
    <div className={cn(className)}>
      <EditorContent
        editor={editor || null}
        className={cn('tiptap-viewer break-words', {
          'night-mode':
            theme === ThemeEnum.NIGHT &&
            Router.pathname === '/story/[id]/chapter/[chapterId]',
          'custom-night-mode text-dark-10':
            (theme === ThemeEnum.NIGHT || theme === ThemeEnum.DARK) &&
            Router.pathname !== '/story/[id]/chapter/[chapterId]',
          'sepia-mode': theme === ThemeEnum.SEPIA,
          'dark-mode':
            theme === ThemeEnum.DARK &&
            Router.pathname === '/story/[id]/chapter/[chapterId]',
          'line-clamp-10 tablet:line-clamp-15 mobile:line-clamp-25':
            (contentLine > 10 || contentSize > 800) &&
            showMoreButton &&
            !showMore,
        })}
      />
      {(contentLine > 10 || contentSize > 800) && showMoreButton && (
        <div className='mb-[10px]' onClick={toggleShowMore}>
          <span className='underline cursor-pointer'>
            {showMore ? 'แสดงน้อยลง' : 'แสดงเพิ่มเติม'}
          </span>
        </div>
      )}
    </div>
  )
}

export default TiptapViewer
